var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leftBottom"},[_c('div',{staticClass:"ad"},[_c('div',{staticClass:"filterBox"}),_c('p',{staticClass:"title"},[_vm._v("网格数据统计")]),_c('div',{staticStyle:{"width":"100%","height":"320px"},attrs:{"id":"pie"}})])])
}]

export { render, staticRenderFns }